import { ReactNode } from 'react';
import { createPortal } from 'react-dom';
import styled from 'styled-components';

const OverLayLayout = styled.div`
  position: fixed;
  z-index: 100001;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgb(0 0 0 / 50%);
  display: flex;
  align-items: center;
  justify-content: center;
`;

interface OverlayProps {
  children: ReactNode;
}

export const Overlay = (props: OverlayProps) => {
  return createPortal(
    <OverLayLayout>{props.children}</OverLayLayout>,
    window.document.body
  );
};
